"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteOfferItem = deleteOfferItem;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
async function deleteOfferItem({
  client,
  itemCode,
  offerId,
  sessionId,
  tenant
}) {
  // TODO -- Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant
  };
  return (0, _globalApiClientReact.deleteShoppingSessionOfferChoice)(client, sessionId, offerId, itemCode, headers);
}